(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (e) {
    var slide = e.target.closest('slideshow-slide[data-banner-url]');
    if (!slide) return;

    // Don't navigate if the click was on a real interactive element inside the slide
    var interactive = e.target.closest('a, button, input, select, textarea, [role="button"]');
    if (interactive && interactive !== slide) return;

    var url = slide.getAttribute('data-banner-url');
    if (url) window.location.href = url;
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    (function () {
    var blockId = '{{ block.id }}';
    var form =
      document.querySelector('[data-block-id="' + blockId + '"] .email-signup__form') ||
      document.querySelector('.email-signup__form:has(#EmailInput-' + blockId + ')');

    // Fallback: find form by the input ID
    var input = document.getElementById('EmailInput-' + blockId);
    if (!input) return;
    var parentForm = input.closest('form');
    if (!parentForm) return;

    var errorBox = document.getElementById('Email-signup__validation-error-' + blockId);
    var errorMsg = errorBox ? errorBox.querySelector('.email-signup__validation-message') : null;

    function showError(msg) {
      if (!errorBox || !errorMsg) return;
      errorMsg.textContent = msg;
      errorBox.style.display = 'flex';
      input.setAttribute('aria-invalid', 'true');
      input.setAttribute('aria-describedby', 'Email-signup__validation-error-' + blockId);
    }

    function clearError() {
      if (!errorBox) return;
      errorBox.style.display = 'none';
      input.removeAttribute('aria-invalid');
    }

    input.addEventListener('input', function () {
      clearError();
    });

    parentForm.addEventListener('submit', function (e) {
      clearError();
      var value = input.value.trim();

      if (value === '') {
        e.preventDefault();
        showError('Please enter your email address.');
        input.focus();
        return;
      }

      // Require a proper TLD: name@domain.tld (2+ letter TLD)
      var emailPattern = /^[a-zA-Z0-9._%+\-]+@[a-zA-Z0-9.\-]+\.[a-zA-Z]{2,}$/;
      if (!emailPattern.test(value)) {
        e.preventDefault();
        showError('Please enter a valid email address.');
        input.focus();
        return;
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
